import * as React from "react";
import * as ReactDOM from "react-dom";
import * as _ from "lodash";
import {connect} from "react-redux";
import {IYear} from "../../../data/data";

interface Props
{
    year: number;
    year_intro?: boolean;
}

import './Calendar.scss';


export default class Calendar extends React.Component<Props, null>
{
    constructor(public props: Props)
    {
        super(props);
    }


    getDigits = () =>
    {
        const {year, year_intro} = this.props;
        const year_str: string = _.toString(year);

        return _.map(year_str, (digit: string, i: number) =>
        {
            return <span
                        styleName={! year_intro ? 'digit' : 'year-intro-digit'}
                        key={i}>

                {digit}

            </span>
        });
    };


    render() : JSX.Element
    {
        return <div styleName={'calendar'}>

            {this.getDigits()}

        </div>
    }
}



// WEBPACK FOOTER //
// ./src/ts/app/common/calendar/Calendar.tsx